import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { AddPropertyFieldComponent } from "../property/PropertyField";

const ToggleButtonGroupField = withStyles(
  {},
  { name: "LcToggleButtonGroupField" }
)(
  ({
    classes,
    name,
    label: labelProp = name,
    value: valueProp,
    disabled: disabledProp,
    onChange,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    exclusive,
    neverNull,
    buttons,
    ...props
  }) => (
    <FieldComponent name={name}>
      {({ form, field }) => {
        const { disabled, value } = getFieldStatus(
          form,
          field,
          valueProp,
          labelProp,
          disabledProp
        );

        const onFieldChange = (e, val) => {
          if (!neverNull || val !== null) {
            form.setFieldValue(name, val, true);
            onChange && onChange(val, form, field);
          }
        };

        return (
          <ToggleButtonGroup
            value={value}
            disabled={disabled}
            exclusive={exclusive}
            onChange={onFieldChange}
          >
            {buttons.map(({ value: val, content, ...rest }, idx) => (
              <ToggleButton key={idx} value={val} {...rest}>
                {content}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        );
      }}
    </FieldComponent>
  )
);

AddPropertyFieldComponent("togglegroup", ToggleButtonGroupField);

export default ToggleButtonGroupField;
